import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20flowing%20shapes%2C%20minimalist%20elegant%20design%2C%20cream%20and%20warm%20golden%20accents%2C%20subtle%20geometric%20patterns%2C%20modern%20brand%20visual%2C%20calm%20premium%20atmosphere&width=1800&height=600&seq=baoyu-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          准备好体验 baoyu 了吗？
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-10 max-w-xl mx-auto leading-relaxed">
          加入全球超过千万用户的 baoyu 大家庭，开启你的非凡之旅
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold transition-all duration-200 whitespace-nowrap hover:bg-primary-600 cursor-pointer"
          >
            立即探索产品
          </Link>
          <Link
            to="/about#contact"
            className="px-8 py-3.5 rounded-full border border-white/30 text-white text-sm font-semibold transition-all duration-200 whitespace-nowrap hover:bg-white/10 cursor-pointer"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}